var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseInRectangleIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon close-in-rectangle-icon",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0a8 8 0 018 8v14a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8h14zm0 1.5H8a6.5 6.5 0 00-6.496 6.267L1.5 8v14a6.5 6.5 0 006.267 6.496L8 28.5h14a6.5 6.5 0 006.496-6.267L28.5 22V8a6.5 6.5 0 00-6.267-6.496L22 1.5zM9.196 8.147l.084.073L15 13.939l5.72-5.72a.75.75 0 011.133.977l-.073.084L16.061 15l5.72 5.72a.75.75 0 01-.977 1.133l-.084-.073L15 16.061l-5.72 5.72a.75.75 0 01-1.133-.977l.073-.084L13.939 15l-5.72-5.72a.75.75 0 01.977-1.133z"
  })));
}

export default SvgCloseInRectangleIconSv;